import { render } from "./Reports.vue?vue&type=template&id=40f83490"
import script from "./Reports.vue?vue&type=script&lang=ts"
export * from "./Reports.vue?vue&type=script&lang=ts"
script.render = render

export default script